import {ColorBackground, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalBackgroundBaseSettings} from "./PortalBackgroundBaseSettings";

export class PortalColorBackground extends ColorBackground implements Parameter {
	constructor(data: any) {
		super(data);

		this.settings = PortalBackgroundBaseSettings.fromJson(data?.settings);
	}

	public static fromJson(data: any): PortalColorBackground {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalColorBackground(data);
	}

	public clone(): PortalColorBackground {
		return PortalColorBackground.fromJson(this.toJson());
	}
}